import { render, staticRenderFns } from "./Ganadores.vue?vue&type=template&id=56eeaa7f&scoped=true&"
import script from "./Ganadores.vue?vue&type=script&lang=js&"
export * from "./Ganadores.vue?vue&type=script&lang=js&"
import style0 from "./Ganadores.vue?vue&type=style&index=0&id=56eeaa7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eeaa7f",
  null
  
)

export default component.exports